import store from "../store/index";
//----------------------------------
// use view combatant action counts
//----------------------------------
export default async function useViewCombatantActionCounts(parm) {
  return new Promise((reject, resolve) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //-----------
    // make call
    //-----------
    this_store
      .dispatch("combat/viewCombatantActionCounts", parm)
      .then((counts) => {
        resolve(counts);
      })
      //-----------------
      // where api error
      //-----------------
      .catch((error) => {
        reject(error);
      });
  });
}
